/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Staff_Avg_ValueInputs */

const vi_report_staff_avg_value = /** @type {(inputs: Report_Staff_Avg_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TB/đơn`)
};

/**

* @param {Report_Staff_Avg_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_staff_avg_value = /** @type {((inputs?: Report_Staff_Avg_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Staff_Avg_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_staff_avg_value(inputs)
});